import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[communicationPhoneDetailDirective]',
})
export class CommunicationPhoneDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}